import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SearchContext } from "../../App";
import { paths } from "../../routes/paths";
import MANUFACTURERS from "../../api/services/MANUFACTURERS";
import Spinner from "../../components/Spinner";
import styles from "../../styles/_features/main/findCard.module.scss";
import downloadImage from "../../assets/down3.gif";
import downloadIos from "../../assets/appstore_btn.png";
import downloadAndroid from "../../assets/googleplay_btn.png";
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import { fieldNames, useLicenseSearch } from "../../hooks/useLicenseSearch";
import LicenseModal from "../../components/LicenseModal";

const FindCard = ({ setIsOpen, dynamicContent }) => {
  let token = localStorage.getItem("authToken");
  token = JSON.parse(token);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  const handleFocus = (e) => {
    if (e.target.value === "שנת ייצור") {
      setYop("");
    }
  };
  const {
    vehicleVal,
    manufacturerVal,
    modelVal,
    subModelVal,
    yopVal,
    gearTypeVal,
    engineTypeVal,
    hpVal,
    licenceNumber,
    disableAllField,
    manuList,
    modelsList,
    collapse,
    licenseAPIData,
  } = useContext(SearchContext);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [vehicle, setVehicle] = vehicleVal;
  const [manufacturer, setManufacturer] = manufacturerVal;
  const [model, setModel] = modelVal;
  const [subModel, setSubModel] = subModelVal;
  const [yop, setYop] = yopVal;
  const [gearType, setGearType] = gearTypeVal;
  const [engineType, setEngineType] = engineTypeVal;
  const [hp, setHp] = hpVal;
  const [licenceNum, setLicenceNum] = licenceNumber;
  const [disableAll, setDisableAll] = disableAllField;
  const [manufacturers, setManufacturers] = manuList;
  const [models, setModels] = modelsList;
  const [collapseSections, setCollapseSections] = collapse;
  const [licenseData, setLicenseData] = licenseAPIData;

  // Enriched data states (mirroring LicenseModal)
  const [hasDisabledTag, setHasDisabledTag] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [recalls, setRecalls] = useState(null);
  const [isRecallsLoading, setIsRecallsLoading] = useState(false);
  const [showRecallDetails, setShowRecallDetails] = useState(false);
  const [isVehicleInactiveA, setIsVehicleInactiveA] = useState(false); // f6efe89a
  const [isVehicleInactiveB, setIsVehicleInactiveB] = useState(false); // 6f6acd03
  const [isVehicleInactiveC, setIsVehicleInactiveC] = useState(false); // 4e6b9724
  const [isVehicleInactiveD, setIsVehicleInactiveD] = useState(false); // 851ecab1
  const [bitulDt, setBitulDt] = useState(null);
  const [priceILS, setPriceILS] = useState(null);
  const [isPriceLoading, setIsPriceLoading] = useState(false);

  const [subModelError, setSubModelError] = useState(null);
  const [yopError, setYopError] = useState(null);
  const [gearTypeError, setGearTypeError] = useState(null);
  const [engineTypeError, setEngineTypeError] = useState(null);
  const [hpError, setHpError] = useState(null);

  const [hasShownPopup, setHasShownPopup] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  // Extra field labels for history dataset
  const historyFieldNames = {
    mispar_rechev: "מספר רישוי",
    mispar_manoa: "מספר מנוע",
    kilometer_test_aharon: "קילומטר בטסט אחרון",
    shinui_mivne_ind: "שינוי מבנה",
    gapam_ind: "האם גפ״מ",
    shnui_zeva_ind: "שינוי צבע",
    shinui_zmig_ind: "שינוי צמיג",
    rishum_rishon_dt: "תאריך רישום ראשון",
    mkoriut_nm: "במקור",
  };

  const recallFieldNames = {
    RECALL_ID: "מזהה ריקול",
    SUG_RECALL: "סוג ריקול",
    SUG_TAKALA: "סוג תקלה",
    TEUR_TAKALA: "תיאור תקלה",
    TAARICH_PTICHA: "תאריך פתיחה",
  };

  const toYesNo = (value) => (Number(value) === 1 ? "כן" : "לא");

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const hasShownPopup = sessionStorage.getItem("hasShownPopup") === "true";

    if (isMobile && !hasShownPopup) {
      const timeoutId = setTimeout(() => {
        setIsModalOpen(true);
        sessionStorage.setItem("hasShownPopup", "true");
      }, 5000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  // Disabled tag check (c8b9f9c8)
  useEffect(() => {
    const plateRaw = licenseData?.mispar_rechev
      ? String(licenseData.mispar_rechev)
      : licenceNum
      ? String(licenceNum)
      : null;
    if (!plateRaw) {
      setHasDisabledTag(null);
      return;
    }
    const numericPlate = parseInt(plateRaw.replace(/\D/g, ""), 10);
    if (!Number.isFinite(numericPlate)) {
      setHasDisabledTag(false);
      return;
    }
    let isCanceled = false;
    setHasDisabledTag(null);
    const filters = encodeURIComponent(
      JSON.stringify({ "MISPAR RECHEV": numericPlate })
    );
    const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=c8b9f9c8-4612-4068-934f-d4acd2e3c06e&limit=5&filters=${filters}`;
    fetch(url, { method: "GET", cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (isCanceled) return;
        const records = d?.result?.records || [];
        const has = records.some((r) => Number(r["SUG TAV"]) === 1);
        setHasDisabledTag(Boolean(has));
      })
      .catch(() => {
        if (isCanceled) return;
        setHasDisabledTag(false);
      });
    return () => {
      isCanceled = true;
    };
  }, [licenseData?.mispar_rechev, licenceNum]);

  // History dataset (56063a99)
  useEffect(() => {
    const plateRaw = licenseData?.mispar_rechev
      ? String(licenseData.mispar_rechev)
      : licenceNum
      ? String(licenceNum)
      : null;
    if (!plateRaw) {
      setHistoryData(null);
      return;
    }
    const numericPlate = parseInt(plateRaw.replace(/\D/g, ""), 10);
    if (!Number.isFinite(numericPlate)) {
      setHistoryData(null);
      return;
    }
    let isCanceled = false;
    setIsHistoryLoading(true);
    setHistoryData(null);
    const filters = encodeURIComponent(
      JSON.stringify({ mispar_rechev: numericPlate })
    );
    const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=56063a99-8a3e-4ff4-912e-5966c0279bad&limit=1&filters=${filters}`;
    fetch(url, { method: "GET", cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (isCanceled) return;
        const records = d?.result?.records || [];
        setHistoryData(records[0] || null);
      })
      .catch(() => {
        if (isCanceled) return;
        setHistoryData(null);
      })
      .finally(() => {
        if (isCanceled) return;
        setIsHistoryLoading(false);
      });
    return () => {
      isCanceled = true;
    };
  }, [licenseData?.mispar_rechev, licenceNum]);

  // Recalls (36bf1404)
  useEffect(() => {
    const plateRaw = licenseData?.mispar_rechev
      ? String(licenseData.mispar_rechev)
      : licenceNum
      ? String(licenceNum)
      : null;
    if (!plateRaw) {
      setRecalls(null);
      setShowRecallDetails(false);
      return;
    }
    const numericPlate = parseInt(plateRaw.replace(/\D/g, ""), 10);
    if (!Number.isFinite(numericPlate)) {
      setRecalls([]);
      setShowRecallDetails(false);
      return;
    }
    let isCanceled = false;
    setIsRecallsLoading(true);
    setRecalls(null);
    setShowRecallDetails(false);
    const filters = encodeURIComponent(
      JSON.stringify({ MISPAR_RECHEV: numericPlate })
    );
    const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=36bf1404-0be4-49d2-82dc-2f1ead4a8b93&limit=100&filters=${filters}`;
    fetch(url, { method: "GET", cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (isCanceled) return;
        const records = d?.result?.records || [];
        setRecalls(records);
      })
      .catch(() => {
        if (isCanceled) return;
        setRecalls([]);
      })
      .finally(() => {
        if (isCanceled) return;
        setIsRecallsLoading(false);
      });
    return () => {
      isCanceled = true;
    };
  }, [licenseData?.mispar_rechev, licenceNum]);

  // Inactive checks A (f6efe89a) + fallback C (4e6b9724)
  useEffect(() => {
    const plateRaw = licenseData?.mispar_rechev
      ? String(licenseData.mispar_rechev)
      : licenceNum
      ? String(licenceNum)
      : null;
    if (!plateRaw) {
      setIsVehicleInactiveA(false);
      setIsVehicleInactiveC(false);
      setBitulDt(null);
      return;
    }
    const numericPlate = parseInt(plateRaw.replace(/\D/g, ""), 10);
    if (!Number.isFinite(numericPlate)) {
      setIsVehicleInactiveA(false);
      setIsVehicleInactiveC(false);
      setBitulDt(null);
      return;
    }
    let isCanceled = false;
    setIsVehicleInactiveA(false);
    setIsVehicleInactiveC(false);
    setBitulDt(null);
    const filters = encodeURIComponent(
      JSON.stringify({ mispar_rechev: numericPlate })
    );
    const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=f6efe89a-fb3d-43a4-bb61-9bf12a9b9099&limit=1&filters=${filters}`;
    fetch(url, { method: "GET", cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (isCanceled) return;
        const records = d?.result?.records || [];
        const hasAny = Array.isArray(records) && records.length > 0;
        setIsVehicleInactiveA(hasAny);
        const first = hasAny ? records[0] : null;
        const rawBitul = first ? first["bitul_dt"] ?? null : null;
        setBitulDt(rawBitul || null);
        if (!hasAny) {
          const padded = String(numericPlate).padStart(8, "0");
          const fbFilters = encodeURIComponent(
            JSON.stringify({ mispar_rechev: padded })
          );
          const fbUrl = `https://data.gov.il/api/3/action/datastore_search?resource_id=4e6b9724-4c1e-43f0-909a-154d4cc4e046&limit=1&filters=${fbFilters}`;
          fetch(fbUrl, { method: "GET", cache: "no-store" })
            .then((rr) => rr.json())
            .then((dd) => {
              if (isCanceled) return;
              const recs = dd?.result?.records || [];
              const hasFb = Array.isArray(recs) && recs.length > 0;
              setIsVehicleInactiveC(hasFb);
              const firstFb = hasFb ? recs[0] : null;
              const fbBitul = firstFb ? firstFb["bitul_dt"] ?? null : null;
              if (!rawBitul && fbBitul) setBitulDt(fbBitul);
            })
            .catch(() => {
              if (isCanceled) return;
              setIsVehicleInactiveC(false);
            });
        }
      })
      .catch(() => {
        if (isCanceled) return;
        setIsVehicleInactiveA(false);
        setIsVehicleInactiveC(false);
        setBitulDt(null);
      });
    return () => {
      isCanceled = true;
    };
  }, [licenseData?.mispar_rechev, licenceNum]);

  // Inactive check B (6f6acd03)
  useEffect(() => {
    const plateRaw = licenseData?.mispar_rechev
      ? String(licenseData.mispar_rechev)
      : licenceNum
      ? String(licenceNum)
      : null;
    if (!plateRaw) {
      setIsVehicleInactiveB(false);
      return;
    }
    const numericPlate = parseInt(plateRaw.replace(/\D/g, ""), 10);
    if (!Number.isFinite(numericPlate)) {
      setIsVehicleInactiveB(false);
      return;
    }
    let isCanceled = false;
    setIsVehicleInactiveB(false);
    const filters = encodeURIComponent(
      JSON.stringify({ mispar_rechev: numericPlate })
    );
    const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=6f6acd03-f351-4a8f-8ecf-df792f4f573a&limit=1&filters=${filters}`;
    fetch(url, { method: "GET", cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (isCanceled) return;
        const records = d?.result?.records || [];
        setIsVehicleInactiveB(Array.isArray(records) && records.length > 0);
      })
      .catch(() => {
        if (isCanceled) return;
        setIsVehicleInactiveB(false);
      });
    return () => {
      isCanceled = true;
    };
  }, [licenseData?.mispar_rechev, licenceNum]);

  // Inactive check D (851ecab1) - comprehensive deregistered vehicles
  useEffect(() => {
    const plateRaw = licenseData?.mispar_rechev
      ? String(licenseData.mispar_rechev)
      : licenceNum
      ? String(licenceNum)
      : null;
    if (!plateRaw) {
      setIsVehicleInactiveD(false);
      return;
    }
    const numericPlate = parseInt(plateRaw.replace(/\D/g, ""), 10);
    if (!Number.isFinite(numericPlate)) {
      setIsVehicleInactiveD(false);
      return;
    }
    let isCanceled = false;
    setIsVehicleInactiveD(false);
    const filters = encodeURIComponent(
      JSON.stringify({ mispar_rechev: numericPlate })
    );
    const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=851ecab1-0622-4dbe-a6c7-f950cf82abf9&limit=1&filters=${filters}`;
    fetch(url, { method: "GET", cache: "no-store" })
      .then((r) => r.json())
      .then((d) => {
        if (isCanceled) return;
        const records = d?.result?.records || [];
        const hasAny = Array.isArray(records) && records.length > 0;
        setIsVehicleInactiveD(hasAny);
        if (hasAny && !bitulDt) {
          const first = records[0];
          const bd = first ? first["bitul_dt"] ?? null : null;
          if (bd) setBitulDt(bd);
        }
      })
      .catch(() => {
        if (isCanceled) return;
        setIsVehicleInactiveD(false);
      });
    return () => {
      isCanceled = true;
    };
  }, [licenseData?.mispar_rechev, licenceNum]);

  // Price lookup (39f455bf)
  useEffect(() => {
    const tozeretCd = licenseData?.tozeret_cd
      ? Number(String(licenseData.tozeret_cd).replace(/\D/g, ""))
      : null;
    const degemCd = licenseData?.degem_cd
      ? Number(String(licenseData.degem_cd).replace(/\D/g, ""))
      : null;
    const tozeretNm = licenseData?.tozeret_nm || null;
    const degemNm = licenseData?.degem_nm || null;
    const sugDegem = licenseData?.sug_degem || null;
    const year = licenseData?.shnat_yitzur
      ? Number(String(licenseData.shnat_yitzur).replace(/\D/g, ""))
      : licenseData?.yop
      ? Number(String(licenseData.yop).replace(/\D/g, ""))
      : null;
    if (!tozeretCd && !tozeretNm && !degemCd && !degemNm && !year) {
      setPriceILS(null);
      setIsPriceLoading(false);
      return;
    }
    let isCanceled = false;
    setPriceILS(null);
    setIsPriceLoading(true);
    const attempts = [];
    if (tozeretCd && degemCd && year && sugDegem)
      attempts.push({
        tozeret_cd: tozeretCd,
        degem_cd: degemCd,
        shnat_yitzur: year,
        sug_degem: sugDegem,
      });
    if (tozeretCd && degemCd && year)
      attempts.push({
        tozeret_cd: tozeretCd,
        degem_cd: degemCd,
        shnat_yitzur: year,
      });
    if (tozeretCd && degemNm && year)
      attempts.push({
        tozeret_cd: tozeretCd,
        degem_nm: degemNm,
        shnat_yitzur: year,
      });
    if (tozeretNm && degemCd && year)
      attempts.push({
        tozeret_nm: tozeretNm,
        degem_cd: degemCd,
        shnat_yitzur: year,
      });
    if (tozeretNm && degemNm && year)
      attempts.push({
        tozeret_nm: tozeretNm,
        degem_nm: degemNm,
        shnat_yitzur: year,
      });
    if (degemNm && year)
      attempts.push({ degem_nm: degemNm, shnat_yitzur: year });
    if (tozeretCd && degemCd)
      attempts.push({ tozeret_cd: tozeretCd, degem_cd: degemCd });
    if (tozeretNm && degemNm)
      attempts.push({ tozeret_nm: tozeretNm, degem_nm: degemNm });

    const pickRecord = (records) => {
      if (!Array.isArray(records) || records.length === 0) return null;
      if (degemNm) {
        const target = String(degemNm).trim().toLowerCase();
        const exact = records.find(
          (r) => String(r["degem_nm"]).trim().toLowerCase() === target
        );
        if (exact) return exact;
      }
      return records[0];
    };

    (async () => {
      for (const filt of attempts) {
        try {
          const filters = encodeURIComponent(JSON.stringify(filt));
          const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=39f455bf-6db0-4926-859d-017f34eacbcb&limit=50&filters=${filters}`;
          const res = await fetch(url, { method: "GET", cache: "no-store" });
          const data = await res.json();
          if (isCanceled) return;
          const records = data?.result?.records || [];
          const rec = pickRecord(records);
          if (rec && rec["mehir"] != null) {
            setPriceILS(Number(rec["mehir"]));
            break;
          }
        } catch (e) {
          if (isCanceled) return;
        }
      }
      if (!isCanceled) setIsPriceLoading(false);
    })();

    return () => {
      isCanceled = true;
    };
  }, [
    licenseData?.tozeret_cd,
    licenseData?.tozeret_nm,
    licenseData?.degem_cd,
    licenseData?.degem_nm,
    licenseData?.sug_degem,
    licenseData?.shnat_yitzur,
    licenseData?.yop,
  ]);

  // call manufacturers API
  const getManufacturers = async () => {
    try {
      const res = await MANUFACTURERS.get(vehicle);

      if (res.result.length === 0) {
        setManufacturers([]);
      } else {
        const sortedManufacturers = res.result.manufacturers.sort((a, b) => {
          // Compare manufacturers' names alphabetically
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });

        setManufacturers(sortedManufacturers);
        setModels(sortedManufacturers[0].models);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  // fetch manufacturers list
  useEffect(() => {
    getManufacturers();
  }, []);

  const onSubmit = (data) => {
    //console.log(data, "Data");

    // handle click
    // const handleClick = () => {
    //console.log("handleClick");
    // setCollapseSections(true);
    navigate(paths.createRequest);
    // };
    // handleClick();
    // //console.log(data);
  };

  // ===========================================================
  // =========== EXAMPLE LICENSE NO: 75348102, 6618355 =========
  // ===========================================================

  const [noResultsText, setNoResultsText] = useState(false);

  const { searchForLicense, loading } = useLicenseSearch();

  const handleLicenseSearch = React.useCallback(
    async (text) => {
      try {
        const response = await searchForLicense(text);
        console.log(response.success, "RESPONSE //////////");
        if (response.success) {
          // SET ALL LICENSE DATA
          setLicenseData(response.data);

          // CHECK IF MANUFACTURER EXISTS IN MANUFACTURERS ARRAY
          let doesExist = (manufacturers || []).find(
            (i) => i.name === response.localData.manufacturer
          );

          // IF IT EXISTS
          if (doesExist) {
            setManufacturer(response.localData.manufacturer);
            setModels(() => {
              if ((doesExist.models || []).includes(response.localData.model)) {
                return doesExist.models;
              } else {
                return [...(doesExist.models || []), response.localData.model];
              }
            });
            setModel(response.localData.model);
          }

          // IF IT DOESN'T EXISTS
          else {
            setManufacturers((prev) => [
              ...(prev || []),
              {
                id: response.localData.manufacturer,
                name: response.localData.manufacturer,
              },
            ]);
            setManufacturer(response.localData.manufacturer);
            setModels([response.localData.model]);
            setModel(response.localData.model);
          }

          // SET OTHER FIELDS
          setVehicle(response.localData.vehicle);

          if (response.localData.yop) {
            setYop(response.localData.yop);
            setLicenseData((prev) => {
              return {
                ...prev,
                shnat_yitzur: response.localData.yop,
              };
            });
          } else {
            setYopError(true);
          }
          if (response.localData.hp) {
            setHp(response.localData.hp);
          } else {
            setHpError(true);
          }
          if (response.localData.gearType) {
            setGearType(response.localData.gearType);
          } else {
            setGearTypeError(true);
          }
          if (response.localData.engineType) {
            setEngineType(response.localData.engineType);
          } else {
            setEngineTypeError(true);
          }
        } else {
          setLicenseData({});
          // toast.error(response.message);
          setNoResultsText(true);
        }
        console.log("FINAL RESP", response);
      } catch (e) {
        console.log("Error while searching license. Reason:", e);
      }
    },
    [manufacturers, searchForLicense]
  );

  const [dropCardOpen, setDropCardOpen] = useState(false);
  const [licenseModalOpen, setLicenseModalOpen] = useState(false);

  return (
    <>
      <Modal
        style={{
          content: {
            height: "auto",
            width: "95%",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          },
        }}
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: "1rem",
            cursor: "pointer",
            fontSize: "24px",
            fontWeight: "bold",
          }}
          onClick={() => setIsModalOpen(false)}
        >
          X
        </div>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            zIndex: 9999,
          }}
        >
          <img src={downloadImage} />
          <p style={{ fontWeight: "bold", fontSize: "1.4em" }}>
            הורידו את האפליקציה שלנו
          </p>
          <p style={{ fontSize: "1.1em", marginBottom: "15px" }}>
            חפשו חלקים וקבלו מחירים והתראות מספקים בזמן אמת ישירות לאפליקציה
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "5px",
            }}
          >
            <a href="https://apps.apple.com/il/app/get-part/id6443868231">
              <img
                style={{ maxWidth: "100%" }}
                src="/assets/images/AppStore.svg"
                alt="appstore"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.gettparts.app">
              <img
                style={{ maxWidth: "100%" }}
                src="/assets/images/GooglePlay.svg"
                alt="google_play"
              />
            </a>
          </div>
          {/* <button style={{
            backgroundColor: 'white',
            padding: '10px 20px',
            fontSize: '18px',
            fontFamily: `"Open Sans", sans-serif`,
            borderRadius:'5px',
            marginTop:'10px'

          }}
            onClick={toggleModal}>סגירה</button> */}
        </div>
      </Modal>
      <div className={styles.container}>
        <h2>{dynamicContent.searchCardTitle}</h2>
        <p>{dynamicContent.searchCardDescription}</p>
        <h4>הזינו מספר רכב או מלאו פרטים</h4>

        {/* license number */}
        <div className={styles.licenseContainer}>
          <form
            className={styles.licenseRight}
            onSubmit={(e) => {
              e.preventDefault();
              if (licenceNum.length >= 5) {
                handleLicenseSearch(licenceNum);
              }
            }}
          >
            <div className={styles.licenseNum}>
              <div className={styles.wrapper}>
                <div className={styles.left}>
                  <input
                    type="text"
                    placeholder="מספר הרכב שלך"
                    value={licenceNum}
                    onChange={(e) => {
                      setNoResultsText(false);
                      // Allow letters too: chassis/VIN numbers can be searched here
                      const cleanValue = e.target.value
                        .replace(/[^0-9A-Za-z]/g, "")
                        .toUpperCase();
                      setLicenceNum(cleanValue);
                    }}
                  />
                </div>
                <div className={styles.right}>
                  <img src="/assets/icons/flag.svg" alt="flag" />
                  IL
                </div>
              </div>
            </div>
            {licenceNum.length >= 5 && (
              <button type="submit">{loading ? <Spinner /> : "חיפוש"}</button>
            )}
          </form>

          {licenseData && (
            <button
              disabled={!Object.keys(licenseData).length}
              onClick={() => setLicenseModalOpen(true)}
            >
              פרטי כלי הרכב
            </button>
          )}

          {dropCardOpen && (
            <div className={styles.dropCard}>
              <span onClick={() => setDropCardOpen(false)}>&times;</span>
              <ul>
                {(isVehicleInactiveA ||
                  isVehicleInactiveB ||
                  isVehicleInactiveC ||
                  isVehicleInactiveD) && (
                  <li>
                    <p style={{ color: "#b71c1c", fontWeight: "bold" }}>
                      שימו לב: על פי נתוני משרד הרישוי רכב זה לא פעיל
                    </p>
                  </li>
                )}
                {bitulDt && (
                  <li>
                    <p>תאריך ירידה מהכביש:</p>
                    <p>{formatDate(bitulDt)}</p>
                  </li>
                )}
                {licenseData?.mispar_rechev && (
                  <li>
                    <p>תו נכה:</p>
                    <p>
                      {hasDisabledTag === null
                        ? "בודק..."
                        : hasDisabledTag
                        ? "כן"
                        : "לא"}
                    </p>
                  </li>
                )}
                {(isPriceLoading || priceILS != null) && (
                  <li>
                    <p>מחירון (מוערך):</p>
                    <p>
                      {isPriceLoading
                        ? "בודק..."
                        : new Intl.NumberFormat("he-IL", {
                            style: "currency",
                            currency: "ILS",
                            maximumFractionDigits: 0,
                          }).format(priceILS)}
                    </p>
                  </li>
                )}
                {!!Object.keys(licenseData).length &&
                  Object.keys(fieldNames).map(
                    (i, idx) =>
                      licenseData[i] && (
                        <li key={idx}>
                          <p>{fieldNames[i]}:</p>
                          <p>{licenseData[i]}</p>
                        </li>
                      )
                  )}
              </ul>
              {/* Recalls toggle and details */}
              {licenseData?.mispar_rechev && (
                <div style={{ marginTop: 8 }}>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <span>קריאת ריקול שלא בוצעה:</span>
                    <strong>
                      {isRecallsLoading
                        ? "בודק..."
                        : Array.isArray(recalls) && recalls.length > 0
                        ? "כן"
                        : "לא"}
                    </strong>
                    {Array.isArray(recalls) &&
                      recalls.length > 0 &&
                      !isRecallsLoading && (
                        <button
                          onClick={() => setShowRecallDetails((v) => !v)}
                          style={{ padding: "2px 8px", fontSize: 12 }}
                        >
                          {showRecallDetails ? "הסתר" : "פרטים"}
                        </button>
                      )}
                  </div>
                  {showRecallDetails &&
                    Array.isArray(recalls) &&
                    recalls.length > 0 && (
                      <ul style={{ marginTop: 6 }}>
                        {recalls.map((r) => (
                          <li key={r["RECALL_ID"]}>
                            <p>
                              {recallFieldNames["RECALL_ID"]}: {r["RECALL_ID"]}
                            </p>
                            <p>
                              {recallFieldNames["SUG_RECALL"]}:{" "}
                              {r["SUG_RECALL"]}
                            </p>
                            <p>
                              {recallFieldNames["SUG_TAKALA"]}:{" "}
                              {r["SUG_TAKALA"]}
                            </p>
                            <p>
                              {recallFieldNames["TEUR_TAKALA"]}:{" "}
                              {r["TEUR_TAKALA"]}
                            </p>
                            <p>
                              {recallFieldNames["TAARICH_PTICHA"]}:{" "}
                              {formatDate(r["TAARICH_PTICHA"])}
                            </p>
                          </li>
                        ))}
                      </ul>
                    )}
                </div>
              )}
            </div>
          )}
        </div>

        {noResultsText && (
          <p
            style={{
              marginBottom: "20px",
              color: "red",
              fontWeight: "bold",
            }}
          >
            לא מצאנו תוצאות עבור מספר הרישוי שהזנת יש להזין את פרטי הרכב באופן
            ידני בתיבה למטה, תודה.
          </p>
        )}

        {/* vehicles */}
        <div className={styles.tabs}>
          <button
            className={`${
              vehicle === "CAR" && !disableAll ? styles.active : ""
            } ${styles.tab}
            ${disableAll ? styles.disable : ""}
            `}
            onClick={() => setVehicle("CAR")}
            disabled={disableAll}
          >
            <img src="/assets/icons/car.svg" alt="car" />
            רכב
          </button>
          <button
            className={`${
              vehicle === "TRUCK" && !disableAll ? styles.active : ""
            } ${styles.tab} ${disableAll ? styles.disable : ""}`}
            onClick={() => setVehicle("TRUCK")}
            disabled={disableAll}
          >
            <img src="/assets/icons/truck.svg" alt="truck" />
            משאית
          </button>
          <button
            className={`${
              vehicle === "BIKE" && !disableAll ? styles.active : ""
            } ${styles.tab} ${disableAll ? styles.disable : ""}`}
            onClick={() => setVehicle("BIKE")}
            disabled={disableAll}
          >
            <img src="/assets/icons/bike.svg" alt="bike" />
            אופנוע
          </button>
        </div>

        <form
          className={styles.form}
          // onSubmit={handleSubmit(onSubmit)}
          onSubmit={() => navigate(paths.createRequest)}
        >
          {/* manufacturer */}
          <select
            {...register("manufacturer", { required: true })}
            name="manufacturer"
            value={manufacturer}
            style={{
              border: errors.manufacturer
                ? "2px solid red"
                : manufacturer === "לא צוין"
                ? "2px solid red"
                : "1px solid #95a5b2",
            }}
            onChange={(e) => {
              setManufacturer(e.target.value);
              setModels(() => {
                let item = manufacturers.find((i) => i.name === e.target.value);
                if (item) {
                  return item.models;
                } else {
                  return null;
                }
              });
            }}
          >
            <option value="" selected disabled>
              בחר יצרן
            </option>
            {manufacturers &&
              manufacturers.map((i) => (
                <option key={i.id} value={i.name}>
                  {i.name}
                </option>
              ))}
          </select>

          {/* model */}
          <select
            {...register("model")}
            name="model"
            value={model}
            style={{
              border:
                errors && errors.model ? "2px solid red" : "1px solid #95a5b2",
            }}
            onChange={(e) => setModel(e.target.value)}
          >
            <option value="" selected disabled>
              בחר דגם
            </option>
            {models &&
              models.map((i) => (
                <option value={i} key={i}>
                  {i}
                </option>
              ))}
          </select>

          {/* sub model */}
          <input
            {...register("subModel", { required: false })}
            type="text"
            value={subModel}
            onChange={(e) => {
              setSubModelError(null);
              setSubModel(e.target.value);
            }}
            placeholder="תת דגם"
            style={{
              border: subModelError ? "2px solid red" : "1px solid #95a5b2",
            }}
          />

          {/* yop */}
          <input
            {...register("yop", { required: true })}
            type="number"
            value={yop}
            onChange={(e) => {
              setYopError(null);
              setYop(e.target.value);
            }}
            placeholder="שנת ייצור"
            // style={{
            //   border:
            //     (errors && errors.yop) || (!yop && manufacturer) || yopError
            //       ? "2px solid red"
            //       : "1px solid #95a5b2",
            // }}
            style={{
              border: yopError ? "2px solid red" : "1px solid #95a5b2",
            }}
          />

          {/* gear type */}
          {vehicle !== "BIKE" && (
            <select
              {...register("gearType")}
              name="gearType"
              value={gearType}
              onChange={(e) => {
                setGearTypeError(null);
                setGearType(e.target.value);
              }}
              style={{
                border:
                  gearTypeError || gearType === "תיבת הילוכים"
                    ? "2px solid red"
                    : "1px solid #95a5b2",
              }}
            >
              <option value="" selected disabled>
                תיבת הילוכים
              </option>
              <option value="AUTOMATIC">אוטומטי</option>
              <option value="MANUAL">ידני</option>
              <option value="TIPTONIC">טיפטרוניק</option>
              <option value="ROBOTIC">רובוטי</option>
            </select>
          )}

          {/* engine type */}
          <select
            {...register("engineType")}
            name="engineType"
            value={engineType}
            onChange={(e) => {
              setEngineTypeError(null);
              setEngineType(e.target.value);
            }}
            style={{
              border: engineTypeError ? "2px solid red" : "1px solid #95a5b2",
            }}
          >
            <option value="" selected disabled>
              סוג מנוע
            </option>
            <option value="GASOLINE">בנזין</option>
            <option value="TURBO GASOLINE">טורבו בנזין</option>
            <option value="DIESEL">דיזל</option>
            <option value="TURBO DIESEL">טורבו דיזל</option>
            <option value="HYBRID">היברידי</option>
            <option value="ELECTRICAL POWER">חשמלי</option>
            <option value="ELECTRICITY/GASOLINE">חשמלי / בנזין</option>
            <option value="בנזין">בנזין</option>
            <option value="GAPAM">גפ"מ</option>
          </select>

          {/* hp */}
          <input
            {...register("hp", { required: engineType !== "ELECTRICAL POWER" })}
            type="text"
            value={hp}
            onChange={(e) => {
              setHpError(null);
              setHp(e.target.value);
            }}
            placeholder={
              engineType === "ELECTRICAL POWER"
                ? "אין נפח ברכב חשמלי"
                : "נפח מנוע"
            }
            disabled={engineType === "ELECTRICAL POWER"}
            style={{
              border: hpError ? "2px solid red" : "1px solid #95a5b2",
              backgroundColor:
                engineType === "ELECTRICAL POWER" ? "#f3f4f6" : undefined,
            }}
          />

          {vehicle === "BIKE" ? (
            <>
              <button
                type="submit"
                disabled={!manufacturer || !model || !yop || !hp}
              >
                <span>{">"}</span>
                חפש לי חלק
              </button>
            </>
          ) : (
            <>
              <button
                type="submit"
                disabled={
                  !manufacturer ||
                  manufacturer === "לא צוין" ||
                  !model ||
                  model === "בחר דגם" ||
                  yop == "שנת ייצור" ||
                  !yop ||
                  (engineType !== "ELECTRICAL POWER" && !hp) ||
                  !engineType ||
                  engineType === "" ||
                  !gearType
                }
              >
                <span>{">"}</span>
                חפש לי חלק
              </button>

              {(!manufacturer ||
                !model ||
                model === "בחר דגם" ||
                yop == "שנת ייצור" ||
                !yop ||
                (engineType !== "ELECTRICAL POWER" && !hp) ||
                !engineType ||
                engineType === "" ||
                !gearType) && (
                // ||
                // gearType === "תיבת הילוכים"
                <>
                  <p
                    style={{
                      color: "red",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    על מנת לחפש יש למלא את כל השדות
                  </p>
                </>
              )}
            </>
          )}

          <p className={styles.demolishText} onClick={() => setIsOpen(true)}>
            אני רוצה לפרסם רכב שלם לפירוק / חלקים
          </p>
        </form>
      </div>
      {licenseModalOpen && (
        <LicenseModal
          setIsOpen={() => setLicenseModalOpen(false)}
          licenseData={licenseData}
        />
      )}
    </>
  );
};

export default FindCard;
